"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThumbnailList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var Box_1 = __importDefault(require("@material-ui/core/Box"));
var MoreTile_1 = require("../../molecules/MoreTile");
var ThumbnailTile_1 = require("../../molecules/ThumbnailTile");
var styles_1 = __importDefault(require("./styles"));
exports.ThumbnailList = react_1.default.memo(function (_a) {
    var idPrefix = _a.idPrefix, _b = _a.thumbs, thumbs = _b === void 0 ? [] : _b, _c = _a.maxDisplayCount, maxDisplayCount = _c === void 0 ? 3 : _c, _d = _a.showMoreTile, showMoreTile = _d === void 0 ? true : _d, _e = _a.onClick, onClick = _e === void 0 ? function () { } : _e, _f = _a.size, size = _f === void 0 ? "50px" : _f, rest = __rest(_a, ["idPrefix", "thumbs", "maxDisplayCount", "showMoreTile", "onClick", "size"]);
    var classes = (0, styles_1.default)({ size: size });
    var slicedThumbArr = (0, react_1.useMemo)(function () { return thumbs.slice(0, maxDisplayCount); }, [thumbs, maxDisplayCount]);
    var more = (0, react_1.useMemo)(function () { return thumbs.length - slicedThumbArr.length; }, [thumbs.length, slicedThumbArr.length]);
    var handleClick = (0, react_1.useCallback)(function (event, index) {
        event.stopPropagation();
        onClick(event, index);
    }, [onClick]);
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", flexWrap: "nowrap", alignItems: "center", height: size, flexBasis: size, className: classes.root }, rest, { children: [slicedThumbArr.map(function (thumb, index) { return ((0, jsx_runtime_1.jsx)(ThumbnailTile_1.ThumbnailTile, { idPrefix: idPrefix, src: thumb, name: thumb, nameVisible: false, maxWidth: size, onClick: function (event) { return handleClick(event, index); }, compact: true, flexGrow: 0 }, thumb)); }), Boolean(more) && showMoreTile && ((0, jsx_runtime_1.jsx)(MoreTile_1.MoreTile, { idPrefix: idPrefix, more: more, maxWidth: size, onClick: function (event) { return handleClick(event, 0); }, compact: true, flexGrow: 0, flexShrink: 1 }))] })));
});
